import { AppBar, styled } from '@mui/material';
import cssStyles from '~/utils/cssStyles';
import { HEADER, NAVBAR } from '~/config';

export const styles = {
  box: {
    my: 1.5,
    color: 'text.primary',
  },

  text: {
    color: 'text.secondary',
    textTransform: 'capitalize',
  },

  toolbar: {
    minHeight: '100% !important',
    px: { lg: 5 },
  },

  logo: {
    mr: 2.5,
  },

  indexBox: {
    flexGrow: 1,
  },

  spacing: {
    xs: 0.5,
    sm: 2,
  },
};

type RootStyleProps = {
  isCollapse: boolean;
  isOffset: boolean;
  verticalLayout: boolean;
  isMasquerade: boolean;
};

export const RootStyle = styled(AppBar, {
  shouldForwardProp: (prop) =>
    prop !== 'isCollapse' &&
    prop !== 'isOffset' &&
    prop !== 'verticalLayout' &&
    prop != 'isMasquerade',
})<RootStyleProps>(({ isCollapse, isOffset, isMasquerade, verticalLayout, theme }) => ({
  ...cssStyles(theme).bgBlur(),
  boxShadow: 'none',
  height: HEADER.MOBILE_HEIGHT,
  zIndex: theme.zIndex.appBar + 1,
  transition: theme.transitions.create(['width', 'height'], {
    duration: theme.transitions.duration.shorter,
  }),
  paddingLeft: NAVBAR.DASHBOARD_COLLAPSE_WIDTH,
  [theme.breakpoints.up('lg')]: {
    paddingLeft: 0,
    height: HEADER.DASHBOARD_DESKTOP_HEIGHT,
    width: `calc(100% - ${NAVBAR.DASHBOARD_NARROW_WIDTH + 1}px)`,
    ...(isMasquerade && {
      top: '46px',
    }),
    ...(isCollapse && {
      width: `calc(100% - ${NAVBAR.DASHBOARD_COLLAPSE_WIDTH}px) !important`,
    }),
    ...(isOffset && {
      height: HEADER.DASHBOARD_DESKTOP_OFFSET_HEIGHT,
    }),
    ...(verticalLayout && {
      width: '100%',
      height: HEADER.DASHBOARD_DESKTOP_OFFSET_HEIGHT,
      backgroundColor: theme.palette.background.default,
    }),
  },
  [theme.breakpoints.up('xl')]: {
    width: `calc(100% - ${NAVBAR.DASHBOARD_WIDTH + 1}px)`,
  },
}));
